// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".d-select{display:flex;width:100%;line-height:1;align-items:center;margin:12px 0}.d-select__select{display:flex;border-radius:0;padding:10px 5px;border:1px solid #f0f1f2}.d-select__label{display:inline-flex;padding-left:8px}.d-select.d-select--vertical{flex-direction:row;flex-wrap:wrap}.d-select.d-select--vertical .d-select__select,.d-select.d-select--vertical .d-select__label{width:100%}.d-select.d-select--vertical .d-select__label{padding-left:0;padding-bottom:8px}", ""]);
// Exports
module.exports = exports;
